import React from 'react';
import TextWithTooltip from '../text-with-tooltip';

const Badge = (props) => {
  const { tooltip, id } = props;
  return (
    <span className="badge-container">
      <TextWithTooltip
        icon={tooltip.icon}
        textClassName="badge badge-pill badge-default"
        toolTipText={tooltip.text}
        id={id}
      />
    </span>
  );
};

export default Badge;
